export default __webpack_public_path__ + "static/media/arrow-bottom.5967ad7b.svg";